import { render } from "./ProfileEdit.vue?vue&type=template&id=0e33ab50&ts=true"
import script from "./ProfileEdit.vue?vue&type=script&lang=ts"
export * from "./ProfileEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__